import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import ReactTable from 'react-table'

import 'react-table/react-table.css'

import ApplicationTable from './ApplicationTable'
import { fetchApplicationList, fetchNewUserList, fetchUserLoginAudit, 
         applicationListSelector, newUserListSelector, auditListSelector } from '../../redux/AdminSlice'

export const Dashboard = () => {
  
  const dispatch = useDispatch()
  useEffect(() => { 
    dispatch(fetchApplicationList())
    dispatch(fetchNewUserList())
    dispatch(fetchUserLoginAudit())
  }, [dispatch])

  const applicationList = useSelector(applicationListSelector)
  const newUserList = useSelector(newUserListSelector)
  const auditList = useSelector(auditListSelector)

  const history = useHistory();
  const handleApplicationTableClick = (application) => {  
    history.push(`/ru/details/${application._id}`)
  }

  return (
    <div className="row" style={{ marginBottom:"50px" }}>
      <div className="col-12">
        <h2>Administrator Tools</h2>
        <div className="row">
          <div className="col-md">
            <h3 style={{textAlign: "center"}}>Applications</h3>
            <ApplicationTable applicationList={applicationList} onRowClick={handleApplicationTableClick}/>
          </div>
        </div>

        <div className="row">
          <div className="col-md">
                <h3 style={{textAlign: "center"}}>Protected Areas</h3>
                <h4>1793 Protected areas, 4 added in last 3 days</h4>

          </div>
        </div>

        <div className="row">
          <div className="col-md" >
            <h3 style={{textAlign: "center"}}>User Access</h3>
            <ReactTable
              className="-striped"
              showPagination={false}
              data={auditList?auditList:[]}
              columns={[
                {
                  Header: 'User ID/Email',
                  accessor: "email",
                },
                {
                  Header: 'Date',
                  id: "createdOn",
                  accessor: event => {
                    if (event?.createdOn?.$date !== undefined) {
                      const eventDate = new Date(event.createdOn.$date)
                      return `${eventDate.toLocaleDateString('en-GB')} ${eventDate.toLocaleTimeString('en-GB')}`
                    }
                  }
                },
                {
                  Header: 'Event',
                  id: 'event',
                  accessor: event => {
                    if (event.event === 'LOGIN') {
                      return 'Login'
                    } else if (event.event === 'LOGOUT') {
                      return 'Logout'
                    } else {
                      return event.event
                    }
                  }
                }
              ]}
              defaultSorted={[
                {
                  id: 'createdOn',
                  desc: true
                }
              ]}
              style={{
                height: "350px"
              }}
            />
          </div>

          <div className="col-md" >
            <h3 style={{textAlign: "center"}}>New Users</h3>
            <ReactTable
              className="-striped"
              showPagination={false}
              data={newUserList?newUserList:[]}
              columns={[
                {
                  Header: 'User ID/Email',
                  accessor: "_id",
                },
                {
                  Header: 'Date added',
                  id: 'ceatedOn',
                  accessor: newUser => {
                    if (newUser?.createdOn?.$date !== undefined) {
                      return new Date(newUser.createdOn.$date).toLocaleDateString('en-GB')
                    }
                  }
                }
              ]}
              getTrProps={() => ({
                style: {
                  cursor: 'auto'
                }
              })}
              style={{
                height: "350px"
              }}
            />
          </div>
        </div>
      </div>
    </div>
    )
}

export default Dashboard
